import React, { memo } from 'react'
import type { Position } from '../../../../proto/generated/position'
import { useSelector } from 'react-redux'
import { RootState } from '../../../../store'
import { Box, Typography } from '@mui/material'
import QuickWidgetDialog from '../../../quickWidgetDialog/quickWidgetDialog'
import { QuickWidgetTypes } from '../../../../reducer/user.reducer'
import { makeSelectQuickModeEnabled } from '../../../../selectors/user'
import { selectPositions } from '../../../../selectors/positions'
import PositionsTableScrollArea from '../../../positionsTable/PositionsTableScrollArea'
import PositionsTotalPnL from '../../../positionsSidebarWidget/PositionsTotalPnL'

const PositionsWidgetTitle: React.FC<{ positions: Position[] }> = ({ positions }) => (
    <Box display="flex" alignItems="center">
        <Typography fontSize={14}>Open Positions</Typography>
        <Typography fontSize={14} mx={1}>
            {' '}
            •{' '}
        </Typography>
        <Typography fontSize={12} fontWeight="light" mr={0.5}>
            P/L
        </Typography>
        <PositionsTotalPnL positions={positions} variant="compact" />
    </Box>
)

const MemoizedPositionsWidgetTitle = memo(
    PositionsWidgetTitle,
    (prev, next) => prev.positions === next.positions
)

const PositionsWidget: React.FC = () => {
    const positions = useSelector(selectPositions)
    const QuickEnableMode = useSelector(makeSelectQuickModeEnabled(QuickWidgetTypes.POSITION))
    const loading = useSelector((state: RootState) => state.positionsStore.loading)

    const title = <MemoizedPositionsWidgetTitle positions={positions} />

    return (
        <QuickWidgetDialog widgetType={QuickWidgetTypes.POSITION} title={title}>
            {!QuickEnableMode && loading ? (
                <Box p={4} textAlign="center">
                    Loading...
                </Box>
            ) : (
                <PositionsTableScrollArea positions={positions} showGreeks={false} />
            )}
        </QuickWidgetDialog>
    )
}

export default memo(PositionsWidget)
